import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendBankTransfer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_5219_27089)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 70,
				cy: 70,
				r: 45,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0443 66.1445H53.9565C53.59 66.1445 53.2861 66.4614 53.2861 66.8486V85.1547C53.2861 85.542 53.5811 85.8588 53.9565 85.8588H86.0443C86.4108 85.8588 86.7147 85.542 86.7147 85.1547V66.8486C86.7147 66.4614 86.4197 66.1445 86.0443 66.1445Z",
			fill: "#6B7B8B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.5858 66.498H83.9222C83.5192 66.498 83.1895 66.8278 83.1895 67.2308V85.5487C83.1895 85.9517 83.5192 86.2815 83.9222 86.2815H87.5858C87.9888 86.2815 88.3185 85.9517 88.3185 85.5487V67.2308C88.3185 66.8278 87.9888 66.498 87.5858 66.498Z",
			fill: "#D5D9DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.0789 66.498H52.4153C52.0123 66.498 51.6826 66.8278 51.6826 67.2308V85.5487C51.6826 85.9517 52.0123 86.2815 52.4153 86.2815H56.0789C56.4819 86.2815 56.8116 85.9517 56.8116 85.5487V67.2308C56.8116 66.8278 56.4819 66.498 56.0789 66.498Z",
			fill: "#D5D9DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.4061 66.498H59.7425C59.3395 66.498 59.0098 66.8278 59.0098 67.2308V85.5487C59.0098 85.9517 59.3395 86.2815 59.7425 86.2815H63.4061C63.8091 86.2815 64.1388 85.9517 64.1388 85.5487V67.2308C64.1388 66.8278 63.8091 66.498 63.4061 66.498Z",
			fill: "#D5D9DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.2586 66.498H76.595C76.192 66.498 75.8623 66.8278 75.8623 67.2308V85.5487C75.8623 85.9517 76.192 86.2815 76.595 86.2815H80.2586C80.6616 86.2815 80.9913 85.9517 80.9913 85.5487V67.2308C80.9913 66.8278 80.6616 66.498 80.2586 66.498Z",
			fill: "#D5D9DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.3185 66.4983C88.3185 66.0953 87.9888 65.7656 87.5858 65.7656H83.9222C83.5192 65.7656 83.1895 66.0953 83.1895 66.4983V68.7423H88.3185V66.4983Z",
			fill: "#BFC7CD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.8116 66.4983C56.8116 66.0953 56.4819 65.7656 56.0789 65.7656H52.4153C52.0123 65.7656 51.6826 66.0953 51.6826 66.4983V68.7423H56.8116V66.4983Z",
			fill: "#BFC7CD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.1388 66.4983C64.1388 66.0953 63.8091 65.7656 63.4061 65.7656H59.7425C59.3395 65.7656 59.0098 66.0953 59.0098 66.4983V68.7423H64.1388V66.4983Z",
			fill: "#BFC7CD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.9913 66.4983C80.9913 66.0953 80.6616 65.7656 80.2586 65.7656H76.595C76.192 65.7656 75.8623 66.0953 75.8623 66.4983V68.7423H80.9913V66.4983Z",
			fill: "#BFC7CD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.2042 62.3306L70.5136 45.7747C70.228 45.5048 69.7765 45.5048 69.4909 45.7747L51.8003 62.3306C51.5792 62.5375 51.5147 62.8434 51.6252 63.1224C51.7358 63.4013 52.0122 63.5723 52.3071 63.5723H87.6882C87.9923 63.5723 88.2595 63.3923 88.37 63.1224C88.4898 62.8524 88.4253 62.5375 88.2042 62.3306Z",
			fill: "#E7ECEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.2759 61.8574H49.7241C49.3259 61.8574 49 62.188 49 62.5921V66.2656C49 66.6697 49.3259 67.0003 49.7241 67.0003H90.2759C90.6741 67.0003 91 66.6697 91 66.2656V62.5921C91 62.188 90.6741 61.8574 90.2759 61.8574Z",
			fill: "#DADEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.4238 85H50.5768C50.1811 85 49.8574 85.3086 49.8574 85.6857V91.1714C49.8574 91.5486 50.1811 91.8571 50.5768 91.8571H89.4238C89.8194 91.8571 90.1431 91.5486 90.1431 91.1714V85.6857C90.1431 85.3086 89.8194 85 89.4238 85Z",
			fill: "#EAECEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.982 88.4297H48.0189C47.6159 88.4297 47.2861 88.7383 47.2861 89.1154V91.1725C47.2861 91.5497 47.6159 91.8583 48.0189 91.8583H91.982C92.385 91.8583 92.7147 91.5497 92.7147 91.1725V89.1154C92.7147 88.7383 92.385 88.4297 91.982 88.4297Z",
			fill: "#D5D9DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.0007 58.4291C72.1309 58.4291 73.8578 56.7022 73.8578 54.572C73.8578 52.4417 72.1309 50.7148 70.0007 50.7148C67.8705 50.7148 66.1436 52.4417 66.1436 54.572C66.1436 56.7022 67.8705 58.4291 70.0007 58.4291Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_5219_27089",
			x: 0,
			y: 0,
			width: 140,
			height: 140,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_5219_27089"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_5219_27089",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSendBankTransfer;
